<template>
  <Form
    class="flex flex-col gap-y-4 w-full"
    :resolver="signupResolver"
    ref="signupForm"
    v-slot="$form"
    v-focustrap
    @keydown.prevent.enter="$emit('submit')"
  >
    <div class="flex gap-x-4 w-full">
      <LabeledField
        label="First Name"
        :field="$form.firstName"
      >
        <InputText
          name="firstName"
          fluid
          data-test="first-name"
        />
      </LabeledField>
      <LabeledField
        label="Last Name"
        :field="$form.lastName"
      >
        <InputText
          name="lastName"
          fluid
          data-test="last-name"
        />
      </LabeledField>
    </div>
    <LabeledField
      label="Email Address"
      :field="$form.email"
    >
      <InputText
        name="email"
        fluid
        data-test="email"
      />
    </LabeledField>
    <LabeledField
      label="Password"
      :field="$form.password"
    >
      <Password
        name="password"
        :feedback="false"
        fluid
        data-test="password"
      />
    </LabeledField>
    <LabeledField
      label="Confirm Password"
      :field="$form.passwordConfirm"
    >
      <Password
        name="passwordConfirm"
        :feedback="false"
        fluid
        data-test="password-confirm"
      />
    </LabeledField>
  </Form>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useAuthStore } from '@/stores/AuthStore.js';
import LabeledField from '@/components/forms/LabeledField.vue';

const signupForm = ref(null);
const signupResolver = zodResolver(
  z
    .object({
      firstName: z.string().min(1),
      lastName: z.string().min(1),
      email: z.string().email(),
      password: z.string().min(5, 'Password must be at least 5 characters'),
      passwordConfirm: z.string().min(5, 'Password must be at least 5 characters'),
    })
    .refine((data) => data.password === data.passwordConfirm, {
      message: "Passwords don't match",
      path: ['passwordConfirm'],
    }),
);

onMounted(() => {
  useAuthStore().signupForm = signupForm.value;
});
</script>
